import CityPageTemplate from "../city-template/CityPageTemplate";
import { alpenaConfig } from "./data";

export default function AlpenaPage() {
  return <CityPageTemplate config={alpenaConfig} />;
}